import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IJSONEditingService = ( createDecorator('jsonEditingService'));
export { IJSONEditingService };
